import CCFStyles from "./ClauseCheckFailed.module.scss";
import ErrorExclaimSVG from "../../assets/images/ErrorInfo.svg";
import Modal from "../Modal/Modal";
import { useEffect, useState } from "react";
import Button from "../Button/Button";
import { useAppSelector } from "../../hooks/store";
import Tooltip from "../Tooltip/Tooltip";

export const ClauseCheckFailedInfo = () => {
  const [showModal, setShowModal] = useState(false);
  const [showFailedInfo, setShowFailedInfo] = useState(false);
  const data = useAppSelector(
    (store) =>
      store?.rootReducer?.vscDashboardReducer?.clauseCheck?.failed_documents
  );

  useEffect(() => {
    setShowFailedInfo(data?.count ? data?.count !== 0 : false);
  }, [data]);

  const handleViewClick = () => {
    setShowModal(true);
  };

  if (!showFailedInfo) {
    return null;
  }

  return (
    <div className={CCFStyles.wrapper}>
      <Modal
        open={showModal}
        title="Review Failed"
        onCancel={() => setShowModal(false)}
        footer={[
          <Button
            key={"back"}
            variant="outlined"
            className={CCFStyles.modalCancel}
            onClick={() => setShowModal(false)}
          >
            Close
          </Button>,
        ]}
      >
        <div className={CCFStyles.ModalWrapper}>
          <div className={CCFStyles.Modallabel}>
            <img src={ErrorExclaimSVG} alt="" />
            <span>
              Below documents have failed to review, Please upload again
            </span>
          </div>
          <div className={CCFStyles.fileList}>
            {data?.results?.map((item: any) => {
              return (
                <div className={CCFStyles.fileCard}>
                  <Tooltip title={item?.displayName}>
                    {" "}
                    <span>{item?.displayName}</span>
                  </Tooltip>
                </div>
              );
            })}
          </div>
        </div>
      </Modal>
      <div className={CCFStyles.label}>
        <img src={ErrorExclaimSVG} alt="" />
        <span>{data?.count} documents failed to review </span>
        <span className={CCFStyles.view} onClick={handleViewClick}>
          View
        </span>
      </div>
    </div>
  );
};
